import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Minus } from 'lucide-react';
import i18n from '../../../../../i18n';
import '../../../../../styles/components/faq-section.scss';

const FAQ_DATA = [
    {
        question: i18n.t('faq_q_register'),
        answer:
            i18n.t('faq_a_register'),
    },
    {
        question: i18n.t('faq_q_participate'),
        answer:
            i18n.t('faq_a_participate')
    },
    {
        question: i18n.t('faq_q_refund'),
        answer:
            i18n.t('faq_a_refund')
    },
    {
        question: i18n.t('faq_q_payment'),
        answer:
            i18n.t('faq_a_payment')
    }
];

class FaqSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openIndex: null,
        };
    }

    toggleItem = (index) => {
        this.setState((prev) => ({
            openIndex: prev.openIndex === index ? null : index,
        }));
    };

    render() {
        const { openIndex } = this.state;

        return (
            <section className="mzf-section">
                <div className="mzf-section__inner">
                    {/* ── Left side ── */}
                    <div className="mzf-section__left">
                        <h2 className="mzf-section__title">
                            {i18n.t('faq_title')}
                        </h2>
                        <p className="mzf-section__desc">
                            {i18n.t('faq_description')}
                        </p>
                        <Link to="/contact" className="mzf-section__btn">
                            {i18n.t('more_details')}
                        </Link>
                    </div>

                    {/* ── Right side — accordion ── */}
                    <div className="mzf-section__right">
                        {FAQ_DATA.map((item, index) => {
                            const isOpen = openIndex === index;
                            return (
                                <div
                                    key={index}
                                    className={`mzf-accordion ${isOpen ? 'mzf-accordion--open' : ''}`}
                                >
                                    <button
                                        className="mzf-accordion__header"
                                        onClick={() => this.toggleItem(index)}
                                        aria-expanded={isOpen}
                                    >
                                        <span className="mzf-accordion__question">
                                            {item.question}
                                        </span>
                                        <span className="mzf-accordion__icon">
                                            {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                                        </span>
                                    </button>

                                    <div
                                        className="mzf-accordion__body"
                                        style={{
                                            maxHeight: isOpen ? '500px' : '0',
                                        }}
                                    >
                                        <div className="mzf-accordion__content">
                                            {item.answer.split('\n').map((line, i) => (
                                                <p key={i} className="mzf-accordion__line">
                                                    {line}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        );
    }
}

export default FaqSection;